module.exports = __webpack_public_path__ + "static/media/Arrow.1c7d320b.svg";